import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% di sconto da {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Risparmia {{percentageAmount}}% sugli articoli selezionati',
  [OfferKindEnum.AmountOffByProducts]: 'Risparmia {{amount}} sugli articoli selezionati',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Risparmia {{amount}} da {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 al prezzo di 1 – Solo oggi',
  [OfferKindEnum.BogoHalfPrice]: 'Compra uno prendi uno a metà prezzo',
  [OfferKindEnum.FreeItemByProducts]: 'Oggi: assicurati il tuo articolo gratuito!',
  [OfferKindEnum.FreeItemByMinSpendValue]: "Oggi: ottieni un articolo gratuito con un minimo d'ordine!",
};

export default OfferLabel;
